import React,{useRef,useState} from 'react'
import './ContactPage.css'
import NavBar from '../../components/Navbar/NavBar'
import Footer from '../../components/Footer/Footer'
import emailjs from '@emailjs/browser';

const ContactPage = () => {

  const[emailSent,setEmailSent] = useState(true);

  const form = useRef<HTMLFormElement>(null);

  const sendEmail = (e:React.FormEvent) => {
    e.preventDefault();
    setEmailSent(false);
    emailjs.sendForm('service_3vwihp5', 'template_krzwt2m', form.current!, 'pFZQxnFzMXR54zHz_')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      }).finally(()=>{
        setEmailSent(true);
      });
  };

  return <>
  <NavBar/>
  <section className='contact-section flex flex-wrap mt-0 md:mt-10 gap-0 md:gap-0 pb-5 sm:pb-0'>
    <div className="contact-image-container  w-full md:w-1/2 h-64 md:h-auto">
        <img src="../../assets/images/sliders/Sara-P-6.jpg" alt="sara-y3" loading='lazy'/>
    </div>
    <div className="form-container flex flex-col justify-center items-center gap-5 w-full md:w-1/2">
        <h3 className='font-[MADE-Bon-Voyage] uppercase'>Contáctame</h3>
        <h6 className='font-[MADE-Bon-Voyage]'>Estoy para mi tribu</h6>
      
      <form ref={form} onSubmit={sendEmail} className='flex flex-col justify-center gap-5'>
        <input type="text" name="user_name" id="name-contact" placeholder='Nombre'/>
        <input type="email" name="user_email" id="email-contact" placeholder='Correo'/>
        <textarea name="message" id="message-contact" cols={30} rows={5} placeholder='Mensaje' />
        <button className='button-29'>{emailSent ? 'Enviar':<>
                               <div
                        role="status"
                        className="flex items-center justify-center"
                      >
                        <svg
                          aria-hidden="true"
                          className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          ></path>
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          ></path>
                        </svg>
                        <span className="sr-only">Enviando...</span>
                      </div></>}</button>
      </form>
    </div>
  </section>
    <Footer/>
  </>
}

export default ContactPage

